import React from 'react';
import { Outlet } from 'react-router-dom';

import { MembershipProvider } from '../contexts/MembershipServiceContext';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';

import Box from '@mui/material/Box';

const LayoutContent = () => {
	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				minHeight: '100vh',
				maxWidth: 1200,
				mx: 'auto',
				px: { xs: 2, md: 4 }
			}}
		>
			<Header />

			<Box
				component='main'
				sx={{
					flex: 1,
					display: 'flex',
					justifyContent: 'center',
					py: 2
				}}
			>
				<Outlet />
			</Box>

			<Footer />
		</Box>
	);
};

const Layout = () => {
	return (
		<MembershipProvider>
			<LayoutContent />
		</MembershipProvider>
	);
};

export default Layout;
